import { findIndex, isEmpty, isObject, remove } from "lodash";
import { confirmAlert } from "react-confirm-alert";
import { ApiClient, createApiClient, errorHandler, IHandlers } from "../services/ApiClient";
import { Session } from "../components/Utils";
import { RootState } from "../store";
import * as types from "./ActionTypes";
import { MARK_ALL_VISITED, MARK_VISITED, SET_ERROR } from "./ActionTypes";
import { history } from "../router";
// import {IControlError} from "../components/Controls";
import { INITIAL_RULES } from "../const/forms";

const api = createApiClient();

export function requestUnchekUpdate(formId: any, valuesId: any) {
	return {
		type: types.REQUEST_UNCHEK_UPDATE,
		payload: {
			formId,
			valuesId,
		},
	};
}

export function createSession(uid: string, obj: object) {
	return (dispath: any) => {
		api.createSession(uid, obj, {
			success: (response) => {
				Session.setSession(response.id);

				dispath({ type: types.CREATE_REQUEST_BEFORE, payload: null });
				dispath(fetchForm(uid, response.id));
				dispath(setFormUid(uid));
				dispath({ type: types.SET_STATUS_DEFAULT, payload: 0 });
			},
		});
	};
}

export function checkedPanel(panelId: string, checked: boolean, error: any | undefined) {
	return (dispath: any) => {
		dispath(setError(panelId, error));
		dispath(addValue(panelId, checked ? "1" : null, false));
		dispath({
			type: types.CHECKED_PANEL,
			payload: {
				panelId,
				checked,
			},
		});
	};
}

export function setNewProcessId(process_id: string, form_type: string) {
	return (dispath: any) => {
		dispath({
			type: types.SET_NEW_PROCESS_ID,
			payload: {
				process_id,
				form_type,
			},
		});
	};
}

export function getForms() {
	return (dispatch: any) => {
		dispatch({ type: types.LOADING_START, payload: "forms" });
		api.getForms({
			success: (response) => {
				dispatch({ type: types.FETCH_FORMS, payload: response });
			},
			anyway: () => {
				dispatch({ type: types.LOADING_FINISH, payload: "forms" });
			},
		});
	};
}

export function getSettings() {
	return (dispatch: any) => {
		api.getSettings({
			success: (response) => {
				// console.log(response);
				dispatch({ type: types.FETCH_SETTINGS, payload: response });
			},
			anyway: () => {
				dispatch({ type: types.FETCH_SETTINGS_FINISHED });
			},
		});
	};
}

export function getFlows(showall?: boolean) {
	return (dispatch: any) => {
		dispatch({ type: types.LOADING_START, payload: "flows" });
		api.getFlows(showall, {
			success: (response) => dispatch({ type: types.GET_FLOWS, payload: response }),
			anyway: () => dispatch({ type: types.LOADING_FINISH, payload: "flows" }),
		});
	};
}

export function getDirections() {
	return (dispatch: any) => {
		api.getDirections({
			success: (response) => dispatch({ type: types.GET_DIRECTIONS, payload: response }),
		});
	};
}

function initRules(dispatch: any, fields, values) {
	if (fields.length > 0) {
		let i = fields.length;

		while (i--) {
			if (typeof fields[i].extra.init !== "undefined") {
				if (typeof INITIAL_RULES[fields[i].extra.init] !== "undefined") {
					INITIAL_RULES[fields[i].extra.init].callback(dispatch, values);
				}
			}
		}
	}
}

export function loadFrom(form_type: string, process_id: number, is_mentor: boolean) {
	return (dispatch: any) => {
		dispatch({ type: types.LOADING_START, payload: "form" });
		api.openForm(form_type, process_id, is_mentor, {
			success: (response) => {
				// Session.setSession(parseInt(valuesId));

				dispatch({ type: types.CREATE_REQUEST_BEFORE, payload: null });
				dispatch({ type: types.OPEN_FORM, payload: { ...response, form_type, process_id } });
				// if (response.direction_id) dispatch(getFlowsByDirections(+response.direction_id));

				const fields = [];
				// const sections = response.form.sections.map((currentValue) => {
				// 	typeof currentValue !== "undefined" && currentValue.controls.map((value) => fields.push(value));
				// });
				if (response.form.sections.length > 0) {
					dispatch({
						type: types.SET_SECTION,
						payload: {
							id: response.form.sections[0].id,
						},
					});
				}
				const autoCompleteFields = fields.filter((field) => field.extra && field.extra.init);

				initRules(dispatch, autoCompleteFields, response.values);
			},
			error: ({ ...props }, error) => {
				const { status } = props;
				if (status === 404) {
					window.location.pathname = "/fasttrack/404/request";
				} else {
					errorHandler(props, error);
				}
			},
			anyway: () => {
				dispatch({ type: types.LOADING_FINISH, payload: "form" });
			},
		});
	};
}

export function fetchValues() {
	return (dispath: any) => {
		dispath(clearValues());
		dispath({ type: types.FETCH_FORM, payload: null });

		api.getAllValues({
			success: (response) => {
				dispath({ type: types.FETCH_VALUES, payload: response });
			},
		});
	};
}

export function redirectInLK(url: string) {
	return (_dispath: any) => {
		const api = createApiClient();
		api.redirect(url);
	};
}

export function setFormUid(uid: string) {
	return {
		type: types.SET_FORM_UID,
		payload: uid,
	};
}

export function createForm(values: any) {
	return (dispatch: any) => {
		const settings = {
			direction_id: values.selectedDirection.value,
		};

		api.createForm(
			{
				settings,
				// || values.selectedCompany.value.company_name,
				// project_name: values.selectedProject.label,
				// orn: values.selectedCompany.value.company_orn
			},
			{
				success: async (response) => {
					const { process_id, form_type } = response;

					await dispatch(setNewProcessId(process_id, form_type));

					history.push(`/fasttrack/forms/${form_type}/${process_id}`);
					dispatch(getForms());
				},
				error: errorHandler,
			}
		);
	};
}

export function rejectApplication(process_id: number, comment: string) {
	return (dispatch: any, getState: () => RootState) => {
		api.rejectApplication(process_id, comment, {
			success: () => {
				const rows = getState().forms.process.all;
				const results = {
					type: types.REMOVE_MENTOR_ROW,
					payload: rows.filter((row) => row.process_id !== process_id),
				};
				dispatch(results);
			},
			error: (_error, _response) => {
				const result = JSON.parse(typeof _response === "string" ? _response : null);
				const message = result?.message ?? "Не удалось отклонить заявку";
				confirmAlert({
					message,
					buttons: [
						{
							label: "Продолжить",
							// eslint-disable-next-line @typescript-eslint/no-empty-function
							onClick: () => {},
						},
					],
				});
			},
		});
	};
}

export function copyForm(form_type: string, process_id: number) {
	return (dispatch: any) => {
		if (window.confirm("Копировать заявку?")) {
			api.copyForm(form_type, process_id, {
				success: (response) => {
					const { process_id, form_type } = response;
					history.push(`/fasttrack/forms/${form_type}/${process_id}`);
					dispatch(getForms());
				},
				error: (_error, _response) => {
					alert("Не удалось скопировать заявку");
				},
			});
		}
	};
}

export function createStatusForm(form_type: string, process_id: number, values: any) {
    return (dispatch: any) => {
        api.createStatusForm(form_type, process_id, { ...values }, {
            success: response => {
                const { link } = response;
				window.location.href = link;
            },
            error: errorHandler,
        })
    }
}

export function deleteForm(form_type: string, process_id: number) {
	return (dispatch: any) => {
		if (window.confirm("Удалить заявку?")) {
			api.deleteForm(form_type, process_id, {
				success: () => {
					dispatch(getForms());
				},
				error: (_error, _response) => {
					confirmAlert({
						message: "Не удалось удалить заявку. Возможно документы уже отправлены",
						buttons: [
							{
								label: "Продолжить",
								// eslint-disable-next-line @typescript-eslint/no-empty-function
								onClick: () => {},
							},
						],
					});
				},
			});
		}
	};
}

export function revokeForm(form_type: string, process_id: number) {
	return (dispatch: any) => {
		if (window.confirm("Отозвать отправленные документы?")) {
			api.revokeForm(form_type, process_id, {
				success: () => {
					dispatch(getForms());
				},
				error: (_error, _response) => {
					confirmAlert({
						message: "Не удалось отозвать документы",
						buttons: [
							{
								label: "Продолжить",
								// eslint-disable-next-line @typescript-eslint/no-empty-function
								onClick: () => {},
							},
						],
					});
				},
			});
		}
	};
}

export function fetchForm(uid: string, values: number) {
	return (dispath: any) => {
		dispath(clearValues());
		dispath({ type: types.FETCH_FORM, payload: null });

		// const checkPanels = [];
		api.getFormByUid(uid, values, {
			success: (response) => {
				dispath({ type: types.FETCH_FORM, payload: { ...response, status: 0 } });
				dispath(setSection(response.sections[0].id));

				history.push(`/create/${uid}/${Session.getSession()}`);
			},
		});
	};
}

export function getHistory(id: string) {
	return (dispatch: any) => {
		dispatch({ type: types.LOADING_START, payload: "request-history" });
		dispatch({ type: types.FETCH_HISTORY });
		api.getHistory(Number(id), {
			success: (response) => {
				dispatch({
					type: types.SET_HISTORY,
					payload: response.sort((a, b) => new Date(b.create_at).getTime() - new Date(a.create_at).getTime()),
				});
				dispatch({ type: types.LOADING_FINISH, payload: "request-history" });
			},
			error: (e) => {
				console.log("ERROR", e);
				dispatch({ type: types.LOADING_FINISH, payload: "request-history" });
			},
		});
	};
}

export function addFile(controlid: string, value: any) {
	return (dispath: any, getState: () => RootState) => {
		const state = getState().forms;
		const result = {
			type: types.ADD_VALUE,
			payload: [...state.values],
		};

		const idx = findIndex(state.values, (o: any) => o.controlid === controlid);

		if (idx > -1 && isEmpty(value)) {
			// delete
			result.payload = remove(state.values, (o: any) => o.controlid !== controlid);
		} else if (idx === -1 && isEmpty(value) === false) {
			// create
			result.payload = [...state.values, { controlid, value }];
		} else if (idx > -1 && isEmpty(value) === false) {
			// update
			result.payload = [...state.values];
			result.payload[idx].value = value;
		}

		dispath(result);
	};
}

function getControlsByType(form: any, type: string) {
	const result = [];
	for (const section of form.sections) {
		const control = section.controls.find((t) => t.type === type);
		if (control) {
			result.push(control);
		}
	}
	return result;
}

function checkRecal(schema: any, controlid: string): boolean {
	const controls: any = getControlsByType(schema, "TotalHeader");
	if (controls.length > 0) {
		const totalHeader = controls[0];
		for (const el of totalHeader.elements) {
			if (controlid.indexOf(el as string) === 0) {
				return true;
			}
		}
	}
	return false;
}

// TODO: ????
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function recaleSumGrant(schema: any, values: any, dispath: any, api: ApiClient) {
	// const controls: any = getControlsByType(schema, 'TotalHeader');
	// const countYear = values.find(t => t.controlid === 'CountYear');
	// if (controls.length > 0){
	//     let total: number = null;
	//     const totalHeader = controls[0];
	//     const lockControl = values.find(t => t.controlid === 'Lock');
	//     for(let control of values) {
	//         for(let el of totalHeader.elements){
	//           if(control.controlid.indexOf(el as string) === 0){
	//             total += parseFloat(control.value);
	//           }
	//         }
	//     }
	//     if(total && (!lockControl || lockControl.value === '0')){
	//         const newState = [...values];
	//         const sumGrantIndex =  values.findIndex(o => o.controlid === 'SumGrant');
	//         const value = countYear.value < 1 ? total.toFixed(2): ((total / 100) * 75).toFixed(2)
	//         if(sumGrantIndex > -1) {
	//             newState[sumGrantIndex].value = value;
	//         } else {
	//             newState.push({ controlid: 'SumGrant', value });
	//         }
	//         dispath({
	//             type: types.ADD_VALUE,
	//             payload: [...newState]
	//         });
	//         api.setValueSync('SumGrant', value);
	//         setError('SumGrant', undefined)(dispath);
	//     }
	// }
}
// TODO: ????
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function recalSumGrantDynamicGrid(schema: any, values: any, dispath: any, api: ApiClient) {
	// const controls: any = getControlsByType(schema, 'DynamicGridPanel');
	// const countYear = values.find(t => t.controlid === 'CountYear');
	// const sumGrantIndex =  values.findIndex(o => o.controlid === 'SumGrant');
	// if(controls.length > 0){
	//     const newState = [...values];
	//     const lockControl = values.find(t => t.controlid === 'Lock');
	//     const stateControl = values.find(t => t.controlid === controls[0].id);
	//     if(stateControl){
	//         const valueTotal: number = stateControl.value.filter(t => t.total).reduce((s,v) => s + parseFloat(v.total),0);
	//         const value = countYear.value < 1 ? valueTotal.toFixed(2): ((valueTotal / 100) * 75).toFixed(2);
	//         if(!lockControl || lockControl.value === '0'){
	//             if(sumGrantIndex > -1) {
	//                 newState[sumGrantIndex].value = value;
	//             } else {
	//                 newState.push({ controlid: 'SumGrant', value });
	//             }
	//             dispath({
	//                 type: types.ADD_VALUE,
	//                 payload: [...newState]
	//             });
	//             api.setValueSync('SumGrant', value);
	//             setError('SumGrant', undefined)(dispath);
	//         }
	//     }
	// }
}

export function recal() {
	return (dispath: any, getState: () => RootState) => {
		const state = getState().forms;
		const api = createApiClient(state.form_type, state.process_id);

		recaleSumGrant(state.form, state.values, dispath, api);
		recalSumGrantDynamicGrid(state.form, state.values, dispath, api);
	};
}

export const ERRORS_MESSAGES = {
	403: "Доступ запрещён",
	404: "Значение не найдено",
	423: "Изменение поля запрещено",
	500: "Внутренняя ошибка сервера",
};

const lockErrorHandler = (dispatch, controlID) => (status: number, _msg: string) => {
	switch (status) {
		case 401: {
			window.location.href = "/#/not-authorized";
			break;
		}
		case 403:
		case 404:
		case 423:
		case 500: {
			confirmAlert({
				message: ERRORS_MESSAGES?.[status] ?? "Что-то пошло не так",
				// eslint-disable-next-line @typescript-eslint/no-empty-function
				buttons: [{ label: "ОК", onClick: () => {} }],
			});
			break;
		}

		default: {
			dispatch(
				setError(controlID, {
					isError: true,
					message: "Невозможно редактировать данное поле",
					isFrontValidation: true,
				})
			);
			break;
		}
	}
	if (status !== 401 && status !== 403 && status !== 404) {
		// console.log(status, msg)
	}
};

export function addValue(controlid: string, value: any, refresh: boolean) {
	return (dispath: any, getState: () => RootState) => {
		const state = getState().forms;
		const newValue = value;

		const api = createApiClient(state.form_type, state.process_id);
		const result = {
			type: types.ADD_VALUE,
			payload: [...state.values],
		};

		const idx = findIndex(state.values, (o: any) => o.controlid === controlid);

		if (idx > -1 && isEmpty(value)) {
			// delete
			result.payload = remove(state.values, (o: any) => o.controlid !== controlid);
			dispath(result);
			api.removeValue(controlid, Date.now(), {
				success: () => {
					// if(controlid === 'SumGrantOld'){
					//     const indexLock = result.payload.findIndex(o => o.controlid === 'Lock');
					//     if(indexLock > -1){
					//         result.payload[indexLock].value = '0'
					//     } else {
					//         result.payload.push({ controlid: 'Lock', value: '0' })
					//     }
					//     api.setValueSync('Lock', '0');
					// }
					dispath(result);
					const lock = result.payload.find((o) => o.controlid === "Lock");
					if ((!lock || lock.value === "0") && checkRecal(state.form, controlid)) {
						// recaleSumGrant(state.form, result.payload, dispath, api);
						// const controls: any = getControlsByType(state.form, 'TotalHeader');
						// if(controls.length > 0){
						//     const totalHeader = controls[0];
						//     let total = null;
						//     for(let control of result.payload) {
						//         for(let el of totalHeader.elements){
						//           if(control.controlid.indexOf(el as string) === 0){
						//             total += parseFloat(control.value);
						//           }
						//         }
						//     }
						//     if(!total){
						//         api.removeValue('SumGrantOld', Date.now(), {
						//             success: () => {
						//                 dispath({
						//                     type: types.ADD_VALUE,
						//                     payload: remove(result.payload, (o:any) => o.controlid !== 'SumGrant')
						//                 });
						//             }
						//         });
						//     }
						// }
					}
					if (controlid === "generate_1") {
						if (!lock || lock.value === "0") {
							// api.removeValue('SumGrant', Date.now(), {
							//     success: () => {
							//         dispath({
							//             type: types.ADD_VALUE,
							//             payload: remove(result.payload, (o:any) => o.controlid !== 'SumGrant')
							//         });
							//     }
							// })
						}
					}
					// recalSumGrantDynamicGrid(state.form, result.payload, dispath, api);

					if (refresh) dispath({ type: types.ATTEMPT_TO_SEND, payload: state.countToSend + 1 });
				},
				error: lockErrorHandler(dispath, controlid),
			});
		} else if (idx === -1 && isEmpty(value) === false) {
			// create
			const values = [...state.values, { controlid, value }];
			dispath({ type: types.ADD_VALUE, payload: values });
			api.setValue(controlid, newValue, {
				success: () => {
					// if(controlid === 'SumGrant') {
					//     const indexLock = values.findIndex(o => o.controlid === 'Lock');
					//     if(indexLock > -1){
					//         values[indexLock].value = '1'
					//     } else {
					//         values.push({ controlid: 'Lock', value: '1' });
					//     }
					//     api.setValueSync('Lock',1);
					// }

					dispath({ type: types.ADD_VALUE, payload: values });
					// if(checkRecal(state.form, controlid))
					//     recaleSumGrant(state.form, values, dispath, api);
					// if (controlid === 'generate_1')
					//     recalSumGrantDynamicGrid(state.form, result.payload, dispath, api);

					if (refresh) dispath({ type: types.ATTEMPT_TO_SEND, payload: state.countToSend + 1 });
				},
				error: lockErrorHandler(dispath, controlid),
			});
		} else if (idx > -1 && isEmpty(value) === false) {
			// update
			if (isObject(newValue) || (!isObject(newValue) && state.values[idx].value !== newValue)) {
				result.payload = [...state.values];
				if (result.payload[idx]) {
					result.payload[idx].value = value;
					dispath(result);
				}
				api.setValue(controlid, newValue, {
					success: () => {
						// if (controlid === 'SumGrant') {
						//     const indexLock = result.payload.findIndex(o => o.controlid === 'Lock');
						//     if (indexLock > -1) {
						//         result.payload[indexLock].value = '1'
						//     } else {
						//         result.payload.push({controlid: 'Lock', value: '1'});
						//     }
						//     api.setValueSync('Lock', 1);
						// }

						dispath(result);
						// if (checkRecal(state.form, controlid))
						//     recaleSumGrant(state.form, result.payload, dispath, api);
						// if (controlid === 'generate_1')
						//     recalSumGrantDynamicGrid(state.form, result.payload, dispath, api);

						if (refresh) dispath({ type: types.ATTEMPT_TO_SEND, payload: state.countToSend + 1 });
					},

					error: lockErrorHandler(dispath, controlid),
				});
			}
		}
	};
}

export function sendPreloadedValue(controlid: string, value: any, refresh: boolean) {
	return (dispath: any, getState: () => RootState) => {
		const state = getState().forms;
		const api = createApiClient(state.form_type, state.process_id);
		const newValue = value;

		api.setValue(controlid, newValue, {
			success: () => {
				if (refresh) dispath({ type: types.ATTEMPT_TO_SEND, payload: state.countToSend + 1 });
			},
		});
	};
}

export function setSection(id: string) {
	return {
		type: types.SET_SECTION,
		payload: {
			id,
		},
	};
}

export function clearValues() {
	return {
		type: types.CLEAR_VALUES,
		payload: {},
	};
}

export function incrimentToSend() {
	return (dispath: any, getState: () => RootState) => {
		const state = getState().forms;

		dispath({ type: types.ATTEMPT_TO_SEND, payload: state.countToSend + 1 });
	};
}

export function removeReportPdf(formId: string, values: string) {
	return (dispath: any) => {
		const api = createApiClient();
		api.removeReportPdf(formId, values, {
			success: () => {
				dispath(fetchValues());
			},
		});
	};
}

export function copyValue(sourceId: string, targetId: string) {
	return (dispath: any, getState: () => RootState) => {
		const { values, formUid } = getState().forms;
		const valueIdx = findIndex(values, (val: any) => val.controlid === sourceId);
		const api = createApiClient(formUid);

		if (valueIdx > -1) {
			const { value } = values[valueIdx];
			if (isObject(value)) {
				api.setValueSync(targetId, value, {
					success: () => {
						dispath({ type: types.ADD_VALUE, payload: [...values, { controlid: targetId, value }] });
					},
				});
			}
		}
	};
}

export function markVisited(id: string) {
	return (dispatch: any) => {
		dispatch({
			type: MARK_VISITED,
			payload: id,
		});
	};
}

export function markAllVisited() {
	return (dispatch: any) => {
		dispatch({
			type: MARK_ALL_VISITED,
		});
	};
}

export function setError(id: string, error: any) {
	return (dispatch) => {
		dispatch({
			type: SET_ERROR,
			payload: {
				id,
				error,
			},
		});
	};
}

export function getCountries() {
	return (dispatch) => {
		api.getCountries({
			success: (response) => {
				dispatch({ type: types.GET_COUNTRIES, payload: response });
			},
		});
	};
}

export function getFlowsByDirections(directionId: number) {
	return (dispatch: any) => {
		dispatch({ type: types.LOADING_START, payload: "flows" });
		api.getFlowByDirection(directionId, {
			success: (response) => dispatch({ type: types.GET_FLOWS, payload: response }),
			error: () => dispatch({ type: types.GET_FLOWS, payload: [] }),
			anyway: () => dispatch({ type: types.LOADING_FINISH, payload: "flows" }),
		});
	};
}

export function welcome(props: any, handlers: IHandlers) {
	return api.welcome(props, handlers);
}

export const setDynamicOption = ({ selectType, options }) => ({
	type: types.SET_DYNAMIC_OPTIONS,
	payload: { selectType, options },
});

// eslint-disable-next-line consistent-return
export const getDynamicOptions = (selectTypes: Array<string>, formType: string) => (dispatch) => {
	if (!Array.isArray(selectTypes)) {
		return null;
	}

	selectTypes.forEach((selectType) => {
		api.getDynamicOptions(
			{
				success: (options) => {
					dispatch(setDynamicOption({ selectType, options }));
				},
			},
			formType,
			selectType
		);
	});
};

export const getAppointed = (process_id) => (dispatch) => {
	api.getAppointedStatus(
		{ process_id },
		{
			success: (resp) => {
				dispatch({ type: types.GET_APPOINTED_STATUS, payload: resp?.status });
			},
		}
	);
};
